import PubSub from "underpub-js";
import Slick from "slick-carousel";
import Plyr from 'plyr/dist/plyr.polyfilled.js';
import loadTouchEvents from 'jquery-touch-events';
loadTouchEvents($);

var HeroBgImageSlider = function(options) {

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

HeroBgImageSlider.prototype.init = function() {

	var self = this;

	// sliders
	this.$imageSlider = this.options.$el.find('.background-slider');
	this.$rightSideTextSlider = this.options.$el.find('.right-side-text-slider');
	this.$textSlider = this.options.$el.find('.text-slider');

	// initialize image slider
	this.$imageSlider.slick({
		arrows: false,
		fade: true,
		speed: 750,
		swipe: false,
	});

	// initialize right side text slider
	this.$rightSideTextSlider.slick({
		arrows: false,
		fade: true,
		speed: 750,
		swipe: false,
	});

	// initialize text slider
	this.$textSlider.slick({
		arrows: false,
		fade: true,
		speed: 200,
		swipe: false,
	});

	// right side text
	this.positionRightSideText();

	PubSub.subscribe("resized", function(){
		self.positionRightSideText();
	});

	PubSub.subscribe("Sitewide:inlineSvgs:svgReplaced", function(){
		self.positionRightSideText();
	});

	// next image button
	this.options.$el.find('.next-image').on('click', function() {

		self.$imageSlider.slick('slickNext');
		self.$rightSideTextSlider.slick('slickNext');
		self.$textSlider.slick('slickNext');

		self.startAutoplay();

	});

	// swipe events
	this.options.$el.on('swiperight', function() {
		self.$imageSlider.slick('slickPrev');
		self.$rightSideTextSlider.slick('slickPrev');
		self.$textSlider.slick('slickPrev');

		self.startAutoplay();
	});

	this.options.$el.on('swipeleft', function() {
		self.$imageSlider.slick('slickNext');
		self.$rightSideTextSlider.slick('slickNext');
		self.$textSlider.slick('slickNext');

		self.startAutoplay();
	});

	// kick off autoplay
	this.startAutoplay();

	// video modal
	this.options.$el.find('.video-modal').each(function() {

		var $this = $(this);
		var $videoPlayer = $(this).find('video');

		var player = new Plyr( $videoPlayer, {
			enabled: true,
			controls: ['progress'],
			settings: ['captions', 'quality', 'speed', 'loop'],
			autoplay: false,
			muted: false,
			clickToPlay: true,
			hideControls: false,
			resetOnEnd: false,
			ratio: null, // The format is 'w:h' - e.g. '16:9' or '4:3'. HTML5 and Vimeo detect ratio automatically, youtube defaults to 16:9
		} );

		$(this).find('.play-button').on('click', function() {

			if ($this.hasClass('playing'))
			{
				console.log('pause');
				player.pause();
			}
			else
			{
				console.log('play');
				player.play();
			}

		});

		player.on('playing', event => {

			const instance = event.detail.plyr;
			
			$this.find('.play-button').removeClass('paused').addClass('playing');

			$this.removeClass('paused').addClass('playing');

		});

		player.on('pause', event => {

			const instance = event.detail.plyr;
			
			$this.find('.play-button').removeClass('playing').addClass('paused');

			$this.removeClass('playing').addClass('paused');

		});

		$(this).find('.close-x').on('click', function() {

			var $modal = $(this).closest('.video-modal').removeClass('active');
			player.pause();

		});

	});

	// video modal triggers
	this.options.$el.find('.video-modal-trigger').on('click', function() {

		var modalId = $(this).data('videoModalId');
		var $modal = $('#' + modalId);
		$modal.addClass('active');

	});

};

HeroBgImageSlider.prototype.startAutoplay = function() {

	var self = this;

	this.autoplayInterval;

	window.clearInterval(self.autoplayInterval);

	this.autoplayInterval = window.setInterval(function() {
		console.log('here');
		self.$imageSlider.slick('slickNext');
		self.$rightSideTextSlider.slick('slickNext');
		self.$textSlider.slick('slickNext');
	}, 8000);

};

HeroBgImageSlider.prototype.positionRightSideText = function() {

	var self = this;

	this.options.$el.find('.right-side-text').each(function() {

		// top
		var $rightSideText = $(this);
		var $contentWrapper = self.options.$el;

		var rightSideTextHeight = $rightSideText.outerWidth(); // element is rotated via css so width is actually height
		var rightSideTextWidth = $rightSideText.outerHeight(); // element is rotated via css so height is actually width

		var contentWrapperHeight = $contentWrapper.outerHeight();
		var contentWrapperWidth = $contentWrapper.width();

		// top
		var newTop = (contentWrapperHeight / 2) - (rightSideTextHeight / 2);
		$rightSideText.css('top', newTop);

		// right
		// pull right by negative height to align with right edge, then move away by 4% width
		// pulling right by negative height aligns with right edge because we're using transform-origin: 0px 0px
		// which means we pull right by negative height (which is width before our transform), and then
		// we swing the item down 90 degrees by it's top left edge
		var newRight = (rightSideTextHeight * -1) + (contentWrapperWidth * 0.04); 
		$rightSideText.css('right', newRight);

	});

};

export default HeroBgImageSlider;
